/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataLeakSeverityEnum } from './DataLeakSeverityEnum';
import {
    DataLeakSeverityEnumFromJSON,
    DataLeakSeverityEnumFromJSONTyped,
    DataLeakSeverityEnumToJSON,
    DataLeakSeverityEnumToJSONTyped,
} from './DataLeakSeverityEnum';
import type { LeakTypeEnum } from './LeakTypeEnum';
import {
    LeakTypeEnumFromJSON,
    LeakTypeEnumFromJSONTyped,
    LeakTypeEnumToJSON,
    LeakTypeEnumToJSONTyped,
} from './LeakTypeEnum';
import type { DataLeakStatusEnum } from './DataLeakStatusEnum';
import {
    DataLeakStatusEnumFromJSON,
    DataLeakStatusEnumFromJSONTyped,
    DataLeakStatusEnumToJSON,
    DataLeakStatusEnumToJSONTyped,
} from './DataLeakStatusEnum';

/**
 * 
 * @export
 * @interface DataLeak
 */
export interface DataLeak {
    /**
     * 
     * @type {number}
     * @memberof DataLeak
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof DataLeak
     */
    snippet: string;
    /**
     * 
     * @type {LeakTypeEnum}
     * @memberof DataLeak
     */
    leakType: LeakTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataLeak
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataLeak
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataLeak
     */
    sourceLink?: string | null;
    /**
     * 
     * @type {DataLeakSeverityEnum}
     * @memberof DataLeak
     */
    severity?: DataLeakSeverityEnum;
    /**
     * 
     * @type {DataLeakStatusEnum}
     * @memberof DataLeak
     */
    status?: DataLeakStatusEnum;
    /**
     * 
     * @type {any}
     * @memberof DataLeak
     */
    otherInfo?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof DataLeak
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DataLeak
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the DataLeak interface.
 */
export function instanceOfDataLeak(value: object): value is DataLeak {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('snippet' in value) || value['snippet'] === undefined) return false;
    if (!('leakType' in value) || value['leakType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DataLeakFromJSON(json: any): DataLeak {
    return DataLeakFromJSONTyped(json, false);
}

export function DataLeakFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataLeak {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'snippet': json['snippet'],
        'leakType': LeakTypeEnumFromJSON(json['leak_type']),
        'category': json['category'] == null ? undefined : json['category'],
        'description': json['description'] == null ? undefined : json['description'],
        'sourceLink': json['source_link'] == null ? undefined : json['source_link'],
        'severity': json['severity'] == null ? undefined : DataLeakSeverityEnumFromJSON(json['severity']),
        'status': json['status'] == null ? undefined : DataLeakStatusEnumFromJSON(json['status']),
        'otherInfo': json['other_info'] == null ? undefined : json['other_info'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function DataLeakToJSON(json: any): DataLeak {
      return DataLeakToJSONTyped(json, false);
  }

  export function DataLeakToJSONTyped(value?: Omit<DataLeak, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snippet': value['snippet'],
        'leak_type': LeakTypeEnumToJSON(value['leakType']),
        'category': value['category'],
        'description': value['description'],
        'source_link': value['sourceLink'],
        'severity': DataLeakSeverityEnumToJSON(value['severity']),
        'status': DataLeakStatusEnumToJSON(value['status']),
        'other_info': value['otherInfo'],
    };
}

